import ministryService from "../../services";
import viewsMeta from "./views-meta";
export default {
  namespaced: true,
  state: () => {
    return {
      dataObj: {},
      loading: false,
    };
  },
  getters: {
    labels() {
      var fieldsArr = [];
      for (const key in viewsMeta) {
        if (Object.hasOwnProperty.call(viewsMeta, key)) {
          const element = viewsMeta[key];
          fieldsArr = [...fieldsArr, ...element.fields];
        }
      }
      fieldsArr = fieldsArr.map((el) => {
        var s = {};
        s[el.key] = el.label;
        return s;
      });

      var arr = fieldsArr.filter((value, index) => {
        const _value = JSON.stringify(value);
        return (
          index ===
          fieldsArr.findIndex((obj) => {
            return JSON.stringify(obj) === _value;
          })
        );
      });

      var mapped = {};
      arr.forEach((el) => {
        var ent = Object.entries(el);
        mapped[ent[0][0]] = ent[0][1];
      });
      return mapped;
    },
    dataObj(state) {
      return state.dataObj;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setData(state, payload) {
      state.dataObj = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    async fetchRecordData({ commit }, params) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchReportRecord(params);
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
